import React, { Component } from 'react';
import { connect } from "react-redux";
import MediaPipeThumbFingerprintCapture from './providers/MediaPipeThumbFingerprintCapture';

class ThumbFingerprintCapture extends Component {
  constructor(props) {
    super(props);
    this.providers = {
      mediapipe: MediaPipeThumbFingerprintCapture,
    };
  }

  render() {
    const providerName = this.props.stepInfo?.thumbFingerprintCaptureProvider || 'mediapipe';
    const ProviderComponent = this.providers[providerName] || this.providers.mediapipe;
    return (
      <ProviderComponent
        nextStep={this.props.nextStep}
        stepInfo={this.props.stepInfo}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    stepInfo: state.stepInfo
  };
};

export default connect(mapStateToProps)(ThumbFingerprintCapture);
